import { Tokens } from "@kalyzee/kast-app-module";
import { Login } from "@kalyzee/kast-web-sdk/adapted-web-components";
import { AuthenticationMethod, AuthenticationResult } from "@kalyzee/kast-web-sdk/web-components";
import { sdkClient } from "../helpers/sdk";
import { toastError } from "../helpers/toast";
import "./Login.css";

interface LoginContainerProps {
  onTokens?: (tokens: Tokens) => void;
}

export const LoginContainer = ({ onTokens }: LoginContainerProps) => {
  const onResult = async (result: AuthenticationResult) => {
    if (result.success) {
      const tokens = result.tokens;
      if (tokens?.token) {
        onTokens?.(tokens);
      }
    } else {
      toastError("Identifiants incorrectes");
    }
  };

  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 20,
      }}
    >
      <Login
        className="login"
        style={
          {
            maxWidth: 550,
            borderRadius: 12,
            width: "80%",
            alignItems: "left",
            display: "flex",
            flexDirection: "column",
            gap: "1em",
            backgroundColor: "white",
            padding: 80,
          } as any
        }
        sdk={sdkClient}
        logo={{
          type: "kalyzee",
        }}
        methods={[AuthenticationMethod.Local]}
        oAuthRedirectUri={window.origin}
        onResult={onResult}
      />
    </div>
  );
};
